module.exports = __webpack_public_path__ + "img/saysimple_logo.974b38d4.svg";